import { Icon } from 'src/components'

import { useUser } from 'src/hook/useUser'
import { ThemeMode } from '@hotmart/space-lib/dist/styles/themes/enum'
import { useDecision } from '@optimizely/react-sdk'
import { ContainerMenuBar, CustomButton, Divider } from './menuBarEditor.styles'
import { getActionsMenuBarEditor } from './utils'
import { MenuBarEditorProps } from './menuBarEditor.types'

const MenuBarEditor = ({
  editor,
  setShowModalLinkEditor,
  shouldShowLinkEditor,
  enableLists
}: MenuBarEditorProps) => {
  const [{ enabled: enableLinkEditor }] = useDecision('com_adm_web_enable_link_editor_tiptap')

  const { theme } = useUser()
  const { actionsLit, oderList } = getActionsMenuBarEditor({
    setShowModalLinkEditor,
    shouldShowLinkEditor,
    enableLinkEditor,
    editor,
    theme: theme as ThemeMode
  })

  if (!editor) return null

  return (
    <ContainerMenuBar
      className="_d-flex _align-items-center _justify-content-start _border-0 _text-left _p-1 _bg-white _rounded"
      data-testid="menu-bar-tiptap"
    >
      {actionsLit.map((action, index) => (
        <CustomButton
          $theme={theme as ThemeMode}
          key={index}
          onClick={action.onClick}
          className={action.className}
          {...(action?.disabled && { disabled: action.disabled })}
        >
          <Icon icon={action.icon} />
        </CustomButton>
      ))}

      {enableLists && (
        <>
          <Divider />

          {oderList.map((action, index) => (
            <CustomButton
              $theme={theme as ThemeMode}
              key={index}
              onClick={action.onClick}
              className={action.className}
            >
              <Icon icon={action.icon} />
            </CustomButton>
          ))}
        </>
      )}
    </ContainerMenuBar>
  )
}

export default MenuBarEditor
